var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: { model: _vm.form, size: "mini", "label-position": "top" }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label:
                      "是否可以拿推荐关系下，代理级别高于自身代理级别的奖励"
                  }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.isCrossLevel,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "isCrossLevel", $$v)
                        },
                        expression: "form.isCrossLevel"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "是否紧缩" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.isTighten,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "isTighten", $$v)
                        },
                        expression: "form.isTighten"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "紧缩拿几代(同级或超越)" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { size: "mini", placeholder: "请选择代数" },
                      model: {
                        value: _vm.form.layer,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "layer", $$v)
                        },
                        expression: "form.layer"
                      }
                    },
                    _vm._l(_vm.layerList, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "拿取对应奖金的唯一标识（必填）" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.bonusTag,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "bonusTag", $$v)
                      },
                      expression: "form.bonusTag"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-card",
        { staticStyle: { "margin-top": "10px" } },
        [
          _c(
            "el-table",
            { staticStyle: { width: "100%" }, attrs: { data: _vm.data } },
            [
              _c("el-table-column", {
                attrs: { label: "会员级别", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: "mini",
                              placeholder: "请选择会员级别"
                            },
                            model: {
                              value: scope.row.grade,
                              callback: function($$v) {
                                _vm.$set(scope.row, "grade", $$v)
                              },
                              expression: "scope.row.grade"
                            }
                          },
                          _vm._l(_vm.gradeData, function(item) {
                            return _c("el-option", {
                              key: item.tag,
                              attrs: { label: item.name, value: item.tag }
                            })
                          }),
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "提成比例", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-row",
                          [
                            _c("el-input-number", {
                              staticStyle: { width: "80%" },
                              attrs: { size: "mini", min: 0, max: 100 },
                              model: {
                                value: scope.row.rate,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "rate", $$v)
                                },
                                expression: "scope.row.rate"
                              }
                            }),
                            _c(
                              "span",
                              { staticStyle: { "margin-left": "10px" } },
                              [_vm._v("%")]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "danger" },
                            on: {
                              click: function($event) {
                                return _vm.clickDelete(scope.$index, scope.row)
                              }
                            }
                          },
                          [_vm._v("删除 ")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "100px", "margin-top": "20px" },
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.clickAddCond }
                },
                [_vm._v("添加等级 ")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { width: "100px", "margin-top": "20px" },
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.clickAddAllCond }
                },
                [_vm._v("添加所有等级 ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }